/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/public/Login'
import LandingPage from '@/components/public/c25LandingPage'
import Dashboard from '@/components/Dashboard'
import c11ControlSystemInterface from '@/components/c11ControlSystemInterface'

Vue.use(Router)

var router = new Router({
  routes: [
    {
      path: '/automatic_user_creation/:newUserEmail/:newUserPassword',
      name: 'automaticUserCreation',
      component: Login,
      meta: {
        breadcrumb: 'Login'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      props: true,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/device-interface/:params?',
      name: 'c11ControlSystemInterface',
      component: c11ControlSystemInterface,
      props: true,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '*',
      redirect: '/login'
    },
    { 
      path: '/:subModals?', 
      name: 'LandingPage',
      props: true,
      component: LandingPage
    }
  ],
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  //p7login handles pushing the redirect URL on sign in
  if (to.name === 'Login' && from.name !== 'Login' && from.name !== 'LandingPage' && from.name !== null) {
    window.G_redirectUrl = from.path;
  }
  next();
});

export default router


// WEBPACK FOOTER //
// ./src/router/index.js